import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect, useDispatch } from 'react-redux';

import { getOpenedTaskId } from '../../../../../redux/general/selectors';
import PriorityDropdown from '../../task-components/PriorityDropdown';
import { editTaskAction } from '../../../../../redux/tasks/actions';
import { getOpenedTaskPriority, getOpenedTaskTitle } from '../../../../../redux/tasks/taskEntities/selectors';

const TaskDetailsPriority = ({ taskId, taskPriority, taskTitle }) => {
  const dispatch = useDispatch();

  const [localPriority, setLocalPriority] = useState('--');

  const taskObj = useMemo(() => ({
    _id: taskId,
    priority: taskPriority,
    taskTitle
  }), [taskId, taskPriority, taskTitle])

  useEffect(() => {
    setLocalPriority(taskPriority === 'nill' ? '--' : taskPriority);
  }, [taskPriority]);
  
  const handleChangePriority = useCallback((priority) => {
    if (localPriority !== priority.rank) {
      setLocalPriority(priority.rank);
      dispatch(editTaskAction({
        _id: taskId,
        taskTitle,
        priority: priority.rank,
      }, null, () => {}));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localPriority, taskId, taskTitle]);

  return (
    <div className="flex items-center py-2.5 pr-2">
      <div className="w-32 shrink-0 flex items-center gap-2">
        <img src="/images/icons/priority-gray.svg" alt="" className="w-4 h-4 shrink-0 opacity-50" />
        <span className="text-[13px] text-[rgba(15,15,25,0.5)] font-medium">
          <FormattedMessage id="PRIORITY" defaultMessage="Priority" />
        </span>
      </div>
      <div className="flex-1 flex justify-end task-priority-pill">
        <PriorityDropdown onClick={handleChangePriority} task={taskObj} />
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  taskId: getOpenedTaskId(state),
  taskPriority: getOpenedTaskPriority(state),
  taskTitle: getOpenedTaskTitle(state),
});

export default connect(mapStateToProps)(TaskDetailsPriority);
